module.exports = __webpack_public_path__ + "img/logo.36c1c9c2.png";